import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheCalmSanctuary from "./sections/TheCalmSanctuary";
import EstateEmblem from "./sections/EstateEmblem";
import PerformanceBenchmarks from "./sections/PerformanceBenchmarks";
import OurCorePromise from "./sections/OurCorePromise";
import ExpertItServices from "./sections/ExpertItServices";
import ThreeSimpleSteps from "./sections/ThreeSimpleSteps";
import VidaEnComunidad from "./sections/VidaEnComunidad";
import VistaportFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheCalmSanctuary />
      <EstateEmblem />
      <PerformanceBenchmarks />
      <OurCorePromise />
      <ExpertItServices />
      <ThreeSimpleSteps />
      <VidaEnComunidad />
      <VistaportFooter />
    </div>;
}